
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mineral-listings/[[...slug]]",
      function () {
        return require("private-next-pages/mineral-listings/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mineral-listings/[[...slug]]"])
      });
    }
  